$(document).ready(function(){

  $('.navbar-toggler').click(function(){
    $(this).toggleClass('open');
  });

  var header = $(".navbar");
  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 350) {
        header.addClass("scrolled");
    } else {
        header.removeClass("scrolled");
    }
  });  

  $('.navbar-nav>li>a').on('click', function(){
    $('.navbar-collapse').collapse('hide');
    $('.navbar-toggler').toggleClass('open');
  });
    

  //Menu On Hover
    
  $('body').on('mouseenter mouseleave','.nav-item',function(e){
      if ($(window).width() > 750) {
        var _d=$(e.target).closest('.nav-item');_d.addClass('show');
        setTimeout(function(){
        _d[_d.is(':hover')?'addClass':'removeClass']('show');
        },1);
      }
  }); 

  /*===================================
  =            Scroll page            =
  ===================================*/
  
  
  $("a[href^='#']").on("click", function(e) {
    $("html, body").animate({
        scrollTop: $($(this).attr("href")).offset().top-40
      }, 1000);
      return false;
  });

  
  /*=====  End of Scroll page  ======*/
  
});

var wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 0,
    mobile: false,
    live: true
});
wow.init();